export const COLLECTION_OPTIONS_TEST_ID = 'CollectionOptions';
export const DELEGATION_ROW_TEST_ID = 'DelegationRow';
